<template>
  <div class="container">
    <div class="information">
      <div v-show="detail.company">
        <span>公司名称</span>
        <p v-html="detail.company"></p>
      </div>
      <div v-show="detail.country">
        <span>国家</span>
        <p>{{detail.country}} </p>
      </div>
      <div v-show="detail.goods">
        <span>主营行业产品</span>
        <p>{{detail.goods}} </p>
      </div>
      <div v-show="detail.buy_industry">
        <span>采购行业</span>
        <p>{{detail.buy_industry}} </p>
      </div>
      <div v-show="buy_industry">
        <span>采购产品</span>
        <p>{{buy_industry}} </p>
      </div>
      <div v-show="detail.facebook||detail.twitter||detail.linkedin">
        <span>社交媒体</span>
        <p><a title="facebook" class="facebook bg" target="_blank" v-show="detail.facebook" :href="detail.facebook"></a><a title="twitter" class="twitter bg" target="_blank" v-show="detail.twitter" :href="detail.twitter"></a><a title="linkedin" class="linkedin bg" target="_blank" v-show="detail.linkedin" :href="detail.linkedin"></a> </p>
      </div>
      <div v-show="detail.address">
        <span>地址</span>
        <p>{{detail.address}} </p>
      </div>
      <div v-show="detail.website">
        <span>网址</span>
        <p>{{detail.website}} </p>
      </div>
      <div v-show="detail.tel">
        <span>电话</span>
        <p>{{detail.tel}} </p>
      </div>
      <div v-show="detail.fox">
        <span>传真</span>
        <p>{{detail.fox}} </p>
      </div>
      <div v-show="detail.email">
        <span>邮箱</span>
        <p>{{detail.email}} </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object, required: true }
  },
  computed:{
    buy_industry(){
      let s=`${this.detail&&(this.detail.buy_industry_cn)||''},${this.detail&&(this.detail.buy_industry_en)||''}`;
      if(s.indexOf(',')==0){
        return s.substring(1);
      }else if(s.lastIndexOf(',')+1==s.length){
         return s.substring(0,s.length-1);
      }else {
        return s
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 500px;
  display: flex;
  flex-flow: row;
  .information {
    width: 100%;
    min-height: 500px;
    box-shadow: 50px 0px 100px #fafafa inset;
    border-left: 1px solid #f2f2f2;
    border-image: linear-gradient(to top, unquote('#f2f2f260'), #f2f2f2, unquote('#f2f2f260')) 1 1;
    & > div {
      color: #666;
      font-size: 13px;
      margin: 20px 0 0;
      display: flex;
      word-break: break-all;
      position: relative;
      & > span {
        text-align:right;
        font-weight: bold;
        width: 80px;
        display: inline-block;
        vertical-align: top;
        margin-right: 20px;
      }
      & > p {
        display: inline-block;
        flex: 1;
        vertical-align: top;
        margin: 0;
        padding: 0;
      }
      &:last-child{
        margin-bottom: 30px;
      }
    }
  }
    .facebook::after{
    width:30px ;
    height: 20px;    
    content: "";
    display: inline-block;
    background-repeat: no-repeat;
    background-position:left;
    background-size:contain;
    background-image: url("~@/assets/img/facebook.png");
  }
    .twitter::after{
    width:30px ;
    height: 20px;      
    content: "";
    display: inline-block;
    background-repeat: no-repeat;
    background-position:left;
    background-size:contain;    
    background-image: url("~@/assets/img/twitter.png");
  }
    .linkedin::after{
    width:30px ;
    height: 20px;
    content: "";
    display: inline-block;
    background-repeat: no-repeat;
    background-position:left;
    background-size:contain;    
    background-image: url("~@/assets/img/linkedin.png");
  }
}
</style>
